import { useEffect } from "react";
import SignInForm from "./SignInForm";
import { useAuthContext } from "../_helper/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import { MANDATORY_CHANGE_PASSWORD_PATH } from "../Routes/PrivateRoute";
import { consumeRedirectPath } from "../utils/redirectStore";

export default function SignIn() {
  const {
    token,
    emailVerificationPending,
    passwordChangeRequired,
  } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from;
  const stateFromPath =
    typeof from === "string"
      ? from
      : from?.pathname
        ? `${from.pathname}${from.search || ""}${from.hash || ""}`
        : null;

  useEffect(() => {
    if (!!token) {
      if (passwordChangeRequired) {
        navigate(MANDATORY_CHANGE_PASSWORD_PATH, { replace: true });
      } else if (emailVerificationPending) {
        navigate("/verify-email", { replace: true });
      } else {
        // consumeRedirectPath reads & clears sessionStorage in one call
        const destination = stateFromPath || consumeRedirectPath() || "/app";
        navigate(destination, { replace: true });
      }
    }
  }, [
    token,
    passwordChangeRequired,
    emailVerificationPending,
    stateFromPath,
    navigate,
  ]);

  return <SignInForm />;
}
